"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledRadioButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledPx2rem = _interopRequireDefault(require("../../utils/styled-px2rem"));
var _templateObject, _templateObject2;
var _excluded = ["className", "children", "checked", "disabled", "name"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var RadioButton = /*#__PURE__*/function (_React$PureComponent) {
  function RadioButton(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RadioButton);
    _this = _callSuper(this, RadioButton, [props]);
    _this.handleRef = _this.handleRef.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(RadioButton, _React$PureComponent);
  return (0, _createClass2["default"])(RadioButton, [{
    key: "handleKeyUp",
    value: function handleKeyUp(_ref) {
      var key = _ref.key;
      if (key !== 'Enter') {
        return;
      }
      var checkbox;
      if (this.el.tagName === 'LABEL') {
        checkbox = this.el.querySelector('input');
      } else {
        checkbox = this.el;
      }
      checkbox.click();
    }
  }, {
    key: "handleRef",
    value: function handleRef(el) {
      this.el = el;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        name = _this$props.name,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var isDescribed = !!children;
      var radioButton = /*#__PURE__*/_react["default"].createElement(StyledRadioButton, (0, _extends2["default"])({}, props, {
        className: isDescribed ? '' : className,
        checked: checked,
        disabled: disabled,
        described: isDescribed,
        name: name,
        onKeyUp: this.handleKeyUp,
        ref: this.handleRef
      }));
      if (!isDescribed) {
        return radioButton;
      }
      return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
        className: className,
        disabled: disabled
      }, radioButton, children);
    }
  }]);
}(_react["default"].PureComponent);
var StyledRadioButton = exports.StyledRadioButton = _styledPx2rem["default"].input.attrs({
  type: 'radio'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  display: block;\n  appearance: none;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n\n  &:before {\n    content: '';\n    display: block;\n    position: relative;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    object-fit: contain;\n    background-color: var(--white);\n    box-shadow: inset 0 0 0 1px var(--grey3);\n  }\n\n  &:checked::before {\n    background-color: var(--secondary);\n    box-shadow: none;\n  }\n\n  &:checked::after {\n    content: '';\n    display: block;\n    position: absolute;\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n    background: var(--white);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.disabled && "\n    cursor: default;\n    opacity: var(--disabled-opacity);\n  ";
}, function (props) {
  return props.described && "\n    margin-right: 8px;\n  ";
});
var StyledLabel = _styledPx2rem["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  cursor: ", ";\n  user-select: none;\n"])), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
});
RadioButton.propTypes = {
  children: _propTypes["default"].node,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]).isRequired
};
RadioButton.defaultProps = {
  children: '',
  checked: false,
  disabled: false,
  className: '',
  onChange: Function.prototype
};
var _default = exports["default"] = RadioButton;